import { Grid, Theme, Box, Typography, Stack } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useLayoutContext } from "Providers/LayoutProvider";
import { motion } from "motion/react";
import { PageAction, PageSubAction } from "consts";

const useHeaderStyle = makeStyles((theme: Theme) => ({
  content: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  primary: {
    color: theme.palette.primary.dark,
  },

  header: {
    display: "flex",
    alignItems: "baseline",
    padding: theme.spacing(3, 0),
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  user: {
    backgroundColor: theme.palette.primary.dark,
    width: 42,
    height: 42,
    borderRadius: "100%",
    overflow: "hidden",
    border: `2px solid ${theme.palette.primary.dark}`,
    "& img": {
      maxWidth: "100%",
    },
  },

  icon: {
    color: theme.palette.primary.dark,
    fontSize: 32,
  },
}));

interface IHeaderProps {
  hideBreadcrumbs?: boolean;
}

export const Header = ({ hideBreadcrumbs }: IHeaderProps) => {
  const headerClasses = useHeaderStyle();
  const { pageTitle, titleAction } = useLayoutContext();

  return (
    <div className={headerClasses.content} id="header">
      <div className={headerClasses.header}>
        <Grid container spacing={4}>
          <Grid item sx={{ flexGrow: 1 }}>
            <Box sx={{ maxWidth: "100%" }}>
              <Box
                id="pageTitle"
                component={motion.div}
                key={pageTitle?.toString() || ""}
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {pageTitle && typeof pageTitle === "function" ? (
                  <>{pageTitle}</>
                ) : pageTitle ? (
                  <Typography variant="h1">{pageTitle}</Typography>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item sx={{ flexGrow: 1 }}>
            <Grid container alignItems={"center"} justifyContent="flex-end">
              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                sx={{ width: "100%" }}
                spacing={2}
              >
                <Box
                  id={PageSubAction}
                  display="flex"
                  justifyContent={"flex-end"}
                />
                <Box id={PageAction}>
                  {titleAction && <Box>{titleAction}</Box>}
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
